import React, { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import { DetailPage } from '@web/app/features/catalog-view/pages/detail';
import { DefaultLayout } from '@web/app/shared';

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
};

export const CatalogViewRoutes = () => {
    return (
        <>
            <ScrollToTop />
            <Routes>
                <Route element={<DefaultLayout />}>
                    <Route path=":catalogId" element={<DetailPage />}></Route>
                    <Route path="*" element={<Navigate to="/"></Navigate>}></Route>
                </Route>
            </Routes>
        </>
    );
};
